<template>
    <div class="l-select-body">
        <div class="l-select" @click="handleShow()">
            <div>{{ year }}</div>
            <div class="icon"></div>
        </div>
        <ul class="l-options" v-if="isList">
            <li v-for="(item, index) in yearList" :key="index" @click="handleYear(item)">{{ item }}</li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isList: false,
            yearList: [

            ],
            year: new Date().getFullYear()
        }
    },
    mounted(){
        for(let i=0;i<5;i++){
            this.yearList.push(new Date().getFullYear()-i)
        }
    },
    methods: {
        handleShow() {
            this.isList = !this.isList
        },
        handleYear(value) {
            this.year = value
            this.isList = false
            this.$emit("changeYear", this.year)
        }
    }


}
</script>
<style scoped lang="stylus">
@import "./index.styl";
</style>